LS.flash = {
	/**
	 * Display flash message
	 *
	 * @param {String} value
	 * @param {String} [status='info']
	 * @param {Object} [options]
	 */
	show(value, status, options) {
		const scope = this;
		const conf = Object.assign({
			html: false,
			timeout: 4000
		}, options);

		let $flash = scope.$flash;

		clearTimeout(scope.autohide);

		if (! $flash) {
			scope.$flash = $flash = $('<div class="flash"/>');

			$flash.on('click', () => {
				scope.hide();
			});

			$(document.body).append($flash);
		} else {
			$flash.removeClass([
				'-success',
				'-warning'
			]);
		}

		if (status) {
			$flash[0].classList.add('-' + status);
		}

		conf.html ?
			$flash.html(value) :
			$flash.text(value);

		requestAnimationFrame(() => {
			if (
				! scope.bound &&
				$.screen.size() < 4 &&
				'visualViewport' in window
			) {
				scope.bound = true;

				scope.position();

				visualViewport.addEventListener('scroll', scope.position);
				visualViewport.addEventListener('resize', scope.position);

				addEventListener('scroll', scope.position);
			}

			$flash[0].classList.add('-is-visible');
		});

		if (scope.visible) {
			const updateClass = '-is-updated';

			$flash.addClass(updateClass)
				.on('transitionend', () => {
					$flash.removeClass(updateClass);
				}, {
					once: true
				});
		}

		scope.visible = true;

		scope.autohide = setTimeout(() => {
			scope.hide();
		}, conf.timeout);
	},

	/**
	 * Position the message
	 */
	position() {
		const mod = LS.flash;

		if (mod.positioning) {
			return;
		}

		mod.positioning = true;

		requestAnimationFrame(() => {
			mod.$flash[0].style.top = visualViewport.offsetTop + 'px';
			mod.positioning = false;
		});
	},

	/**
	 * Hide flash container
	 */
	hide() {
		const scope = this;

		scope.visible = false;

		if (scope.$flash) {
			scope.$flash.removeClass('-is-visible');
		}

		if (scope.bound) {
			visualViewport.removeEventListener('scroll', scope.position);
			visualViewport.removeEventListener('resize', scope.position);

			removeEventListener('scroll', scope.position);
		}
	}
};